module.exports = __webpack_public_path__ + "img/emoji-facebook-friends-240x240.46889a73.png";